import { Selector, createSelector } from "reselect";
import { SharedCallsData } from "@sms/shared/calls/calls.interface";

import { ApplicationStore } from "../application.store";

export const selectCallIds: Selector<ApplicationStore, string[]> = createSelector(
  (state: ApplicationStore): SharedCallsData[] => state.callsStore.calls,
  calls => calls.map(call => call.id)
);

export const makeSelectCallInfoById: () => Selector<ApplicationStore, SharedCallsData | undefined> = (): Selector<
  ApplicationStore,
  SharedCallsData | undefined
> =>
  createSelector(
    (state: ApplicationStore): SharedCallsData[] => state.callsStore.calls,
    (_: ApplicationStore, callId: string): string => callId,
    (calls, callId) => calls.find(call => call.id === callId)
  );
